<template>
   <v-layout wrap>
       <v-flex xs12>
      <galleryComp
              @stepper="galleryStepper"
              :height="'5118'"
              :width="'8001'"
              :heading="'Upload Cover Image'"
               :componentType="'coverImage'"  
            />
       </v-flex>
       <v-flex xs12>
           {{coverImageFile}}

       </v-flex>
       <v-flex @click="cut(item)" xs4 v-for="(item,i) in url7" :key="i">
           <v-badge
                  icon="mdi-check-circle-outline"
                  overlap
                  background-color="green"
                >
           <img width="80px" height="80px" :src="item" >
           </v-badge>
       </v-flex>
   </v-layout>
</template>
<script>
import galleryComp from "./sampleMult.vue"
export default {
    components:{
        galleryComp

    },
    data()
    {
        return{
            coverImageFile:[],
            url7:[]
        }
    },
    methods:

    {
         galleryStepper(window_data) {
      if (window_data.type == "coverImage") {
        this.coverImageFile.push(window_data.selectedFiles)
       this.urlgallery.push( URL.createObjectURL(window_data.selectedFiles
       ));
        console.log("cover image is",this.coverImageFile)
      } 
    },
    cut(value)
    {
     this.coverImageFile.splice(value, 1)
     this.url7.splice(value, 1)
    }

    }
}
</script>